<template>
<div>
    <Header />
    <div class="desktop">
        <BlackHeaderCenter :headerText="headerText" :subText="subText" :fadedText="fadedText" />
    </div>
    <div class="mobile">
        <BlackHeaderMobile :headerText="headerText" :subText="subText" :fadedText="fadedText" :isTextinput="false" />
    </div>
    <BodyLinks />
    <b-container class="mt-4">
        <Activation />
        <b-row align-h="center" class="mt-3">
            <b-col cols="10">
                <p class="font-weight-bold font18">Order Information</p>
            </b-col>
        </b-row>
        <b-row align-h="center" class="">
            <b-col cols="12" md="12" lg="10" class="mt-3 mb-5">
                <b-row class="desktop text-center tab-header mb-2">
                    <b-col cols="5">
                        Item
                    </b-col>
                    <b-col cols="2">
                        Quantity
                    </b-col>
                    <b-col cols="2">
                        Unit Price
                    </b-col>
                    <b-col cols="3">
                        Subtotal
                    </b-col>
                </b-row>
                <b-row class="tab-body" v-for="(item, index) in cart" :key="index">
                    <!-- <span hidden>{{item.quantity = 1}}</span> -->
                    <b-col cols="2">
                        <img :src="item.images" class="img-product" alt="">
                    </b-col>
                    <b-col cols="4" md="3">
                        <router-link class="font14" :to="{ name: 'product-details', params: {id: item.product_id} }">{{item.name | truncate(30)}}</router-link>
                        <p class="font14" v-if="item.business">{{item.business.name}}</p>
                        <a @click="deleteItem(index)" href="#" class="font12">
                            <b-icon icon="trash"></b-icon> Delete
                        </a>
                    </b-col>
                    <b-col cols="3" md="2">
                        <b-form-input @input="calculateTotal(item)" class="custom-control" v-model="item.qty" type="number" min="1" placeholder="1"></b-form-input>
                    </b-col>
                    <b-col cols="3" md="2" class="desktop text-center">
                        <p class=" culture-primary font16 font-weight-bold">${{item.discount_price}}</p>
                    </b-col>
                    <b-col cols="3" md="3">
                        <p class="text-center culture-primary font16 font-weight-bold">${{item.totalPrice.toFixed(2)}}</p>
                    </b-col>
                </b-row>
                <b-row v-if="cart.length == 0">
                    No item in cart yet
                </b-row>
                <b-row class="desktop justify-content-end mt-5">
                    <router-link to="/products/shop" class="btn btn-secondary">Continue Shopping</router-link>
                    <router-link v-if="cart.length > 0" :to="{ name: 'cart-checkout', params: {cart: cart} }" class="btn btn-warning ml-3">Proceed to checkout</router-link>
                </b-row>
                <b-row class="mobile justify-content-between mt-5">
                    <router-link style="font-size:11px" to="/products/shop" class="btn btn-secondary">Continue Shopping</router-link>
                    <router-link v-if="cart.length > 0" style="font-size:11px" :to="{ name: 'cart-checkout', params: {cart: cart} }" class="btn btn-warning ml-3">Proceed to checkout</router-link>
                </b-row>
            </b-col>
        </b-row>
    </b-container>
    <Footer />
</div>
</template>

<script>
import Header from "@/components/Header/Header.vue";
import BodyLinks from "@/components/BodyLinks.vue";
import Footer from "@/components/Footer.vue";
import BlackHeaderCenter from "@/components/BlackHeaderCenter.vue";
import BlackHeaderMobile from "@/components/BlackHeaderMobile.vue";
import Activation from "@/components/Activation.vue";

export default {
    name: 'cart',
    components: {
        Header,
        BodyLinks,
        BlackHeaderCenter,
        BlackHeaderMobile,
        Activation,
        Footer
    },
    data: function () {
        return {
            headerText: "Culture Store",
            btnText: 'Order',
            subText: "Find all sort of local products around the world",
            fadedText: "Shop",
            imgUrl: require('../assets/images/dress.png'),
            portraitImg: require('../assets/images/dress-potrait.png'),
        }
    },
    computed: {
        cart: function () {
            return this.$store.getters.cart;
        },
        currentUser: function () {
            return this.$store.getters.currentUser;
        }
    },
    mounted() {
        this.cart.forEach(item => {
            item.totalPrice = parseFloat(item.discount_price * item.qty)
        });
    },
    methods: {
        processOrder() {
            console.log("from here")
        },
        searchCart(text) {
            console.log(text)
        },
        calculateTotal(item) {
            const totalPrice = item.discount_price * item.qty
            item.totalPrice = Number(totalPrice.toFixed(2))
        },
        deleteItem(item) {
            if (confirm("Do you really want to delete this item?")) {
                this.cart.splice(item, 1);
            }
        },
        // checkout() {
        //     const total = this.cart.reduce((n, {
        //         totalPrice
        //     }) => n + totalPrice, 0)
        //     console.log(total)
        // }
    }

}
</script>

<style lang="scss" scoped>
.row {
    margin-left: 0 !important
}

.tab-header {
    background: #F7F7F7;
    box-shadow: 0px 6px 30px rgb(0 0 0 / 12%);
    padding: 1rem;
}

.col-2 {
    padding-left: 0 !important;
}

.img-product {
    width: 120px;
    height: 104px;

    @media screen and (min-device-width: 320px) and (max-device-width: 640px) and (-webkit-min-device-pixel-ratio: 1) {
        width: 40px;
        height: 40px
    }

    @media screen and (min-device-width: 760px) and (max-device-width: 1024px) and (-webkit-min-device-pixel-ratio: 1) {
        width: 90px;
        height: 90px
    }
}

.tab-body {
    background: #000000;
    box-shadow: 0px 6px 30px rgba(0, 0, 0, 0.12);
    padding: 8px;
    color: #fff
}

.tab-body a {
    color: #fff
}

.tab-body a .b-icon.bi {
    color: #F7B131
}

.location-topbar {
    padding: 10px 12px;
    background: rgba(86, 92, 99, 0.05);
    border-radius: 4px;
    font-size: 14px;
    color: #565C63;
}

.location-bottombar {
    padding: 10px 12px;
    background: #565C63;
    border-radius: 4px;
    font-size: 14px;
    color: #fff;
    text-align: center;
}

.custom-control {
    background: #565C63 !important;
    box-shadow: 0px 4px 14px rgba(0, 0, 0, 0.1);
    border-radius: 4px !important;
    color: #fff !important
}

.custom-card {
    box-shadow: 0px 6px 30px rgba(0, 0, 0, 0.12) !important;
    border-radius: 4px;
    border: none !important;
    background: #FCFCFC;
}

.sidecard {
    box-shadow: 2px 6px 19px rgb(0 0 0 / 3%);
    border-radius: 4px;
    padding: 16px !important;
    border: none !important;
}

.card-body button {
    width: 100%
}
</style>
